import Modal from './Modal';
import { useModal } from '../contexts';
import { useTranslation } from 'react-i18next';

interface Props {
  onConfirm: () => void;
}

function UnsavedContentModal(props: Props) {
  const { onConfirm } = props;
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    closeModal();
  }

  return (
    <Modal
      title={t("You have unsaved content!")}
      subtitle={t("If you go to a different section right now, the changes you made will be lost.")}
      secondaryButtonProps={{ text: t("Cancel"), onClick: closeModal }}
      primaryButtonProps={{ className: "btn-red", onClick: handleConfirm, text: t("Confirm") }}
      size='sm'
    />
  );
}

export default UnsavedContentModal;
